<div *ngIf="step === 1">
  <h2 class="nomargin">Invite hosts to connect their accounts</h2>
  <p>
    If you are managing listings on behalf of others, you can invite them to securely connect their Airbnb account to
    your
    {{ 'CORE.PRODUCT_NAME' | transloco }} account.
  </p>

  <div class="flex justify-end items-center">
    <div class="flex gap-4">
      <sbnb-button label="Cancel" type="secondary" [routerLink]="['/accounts']"></sbnb-button>
      <sbnb-button label="Continue" (clicked)="step = (shouldShowScopeTypeSelection() ? 2 : 3)"></sbnb-button>
    </div>
  </div>
</div>

<div *ngIf="step === 2">
  <h2 class="m-0">Choose a connection type</h2>
  <p>
    To get started, choose between a Full or Limited connection.
    Full gives Hospitable full control of invited host's listing, while Limited can work with another management provider but with fewer features.
  </p>
  <div class="flex flex-col gap-4 mb-4">
    <sbnb-radio-card class="flex-1" [selected]="scopeType === 'pms'" (click)="scopeType = 'pms'">
      <div>
        <h4 class="inline-block">Full Connection</h4>
        <span class="night-lighter text-sm ml-1">(Default)</span>
      </div>
      <p>Hospitable becomes the primary software, taking full control of the Airbnb listings and calendar.</p>
      <ul class="grid grid-cols-2 grid-rows-2 gap-x-2 gap-y-1 p-0">
        <li class="flex gap-1 items-center">
          <sbnb-icon icon="check" class="text-grass-darker"></sbnb-icon>
          Manage calendar availability & prices
        </li>
        <li class="flex gap-1 items-center">
          <sbnb-icon icon="check" class="text-grass-darker"></sbnb-icon>
          Import listings and reservations
        </li>
        <li class="flex gap-1 items-center">
          <sbnb-icon icon="check" class="text-grass-darker"></sbnb-icon>
          Sync calendars across other channels
        </li>
        <li class="flex gap-1 items-center">
          <sbnb-icon icon="check" class="text-grass-darker"></sbnb-icon>
          Automate guest messaging with AI
        </li>
      </ul>
    </sbnb-radio-card>

    <sbnb-radio-card class="flex-1" [selected]="scopeType === 'ops'" (click)="scopeType = 'ops'">
      <h4>Limited Connection</h4>
      <p>Hospitable connects to Airbnb with limited control over the listings even if invited host has another management provider connected.</p>

      <ul class="grid grid-cols-2 grid-rows-2 gap-x-2 gap-y-1 p-0">
        <li class="flex gap-1 items-center">
          <sbnb-icon icon="cancel" class="text-raspberry"></sbnb-icon>
          Manage calendar availability & prices
        </li>
        <li class="flex gap-1 items-center">
          <sbnb-icon icon="check" class="text-grass-darker"></sbnb-icon>
          Import listings and reservations
        </li>
        <li class="flex gap-1 items-center">
          <sbnb-icon icon="cancel" class="text-raspberry"></sbnb-icon>
          Sync calendars across other channels
        </li>
        <li class="flex gap-1 items-center">
          <sbnb-icon icon="check" class="text-grass-darker"></sbnb-icon>
          Automate guest messaging with AI
        </li>
      </ul>
    </sbnb-radio-card>
  </div>

  <div class="flex justify-end items-center">
    <div class="flex gap-4">
      <sbnb-button label="Go back" type="secondary" (clicked)="step = 1"></sbnb-button>
      <sbnb-button label="Continue" (clicked)="step = 3"></sbnb-button>
    </div>
  </div>
</div>

<div *ngIf="step === 3">
  <h2 class="nomargin">Enter your hosts’ contact details</h2>
  <p>
    {{ 'CORE.PRODUCT_NAME' | transloco }} will send an email to the contacts you will invite. Both yourself and our
    support team will be in copy in case they reach out.
  </p>

  <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
    <label fxFlex class="form-label" for="code">Full name</label>
    <label fxFlex class="form-label" for="code">Email</label>
  </div>

  <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px" *ngFor="let invitee of invitees" class="invitee">
    <mat-form-field class="fw">
      <input matInput [(ngModel)]="invitee.name" fxFlex type="text" placeholder="Eg. John Doe" />
    </mat-form-field>

    <mat-form-field class="fw">
      <input matInput [(ngModel)]="invitee.email" fxFlex type="email" [placeholder]="config.EMAIL_PLACEHOLDER" />
    </mat-form-field>
  </div>

  <button class="button__text" (click)="invitees.push({ name: '', email: '' })">+ Add another</button>

  <div class="flex justify-end items-center gap-4">
    <sbnb-button label="Go back" type="secondary" (clicked)="step = (shouldShowScopeTypeSelection() ? 2 : 1)"></sbnb-button>
    <sbnb-button label="Continue" [disabled]="saving" [loading]="saving" (clicked)="sendInvites()"></sbnb-button>
  </div>
</div>

<div *ngIf="step === 4" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="24px">
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M73.3327 36.9342V40.0008C73.3286 47.1889 71.001 54.1831 66.6971 59.9403C62.3932 65.6974 56.3436 69.9091 49.4505 71.9472C42.5575 73.9853 35.1902 73.7405 28.4476 71.2495C21.705 68.7584 15.9482 64.1545 12.0359 58.1244C8.12357 52.0943 6.26532 44.9611 6.73827 37.7886C7.21122 30.6161 9.99004 23.7886 14.6603 18.3244C19.3305 12.8602 25.642 9.05212 32.6533 7.468C39.6647 5.88388 47.0002 6.60864 53.566 9.53418"
      stroke="#47C693" stroke-width="6.15" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M73.3333 13.333L40 46.6997L30 36.6997" stroke="#47C693" stroke-width="6.15" stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>

  <h2 class="nomargin">All invites sent successfully!</h2>
  <p>You will be informed by email as soon as their listings are connected.</p>
  <sbnb-button label="Return to connected accounts" [routerLink]="['/accounts']"></sbnb-button>
</div>
